exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-file[data-v-15ef0634]{height:300px}.custom-file input[data-v-15ef0634]{width:calc(100% + 30px);height:100%;left:-15px}.custom-file .custom-file-label[data-v-15ef0634]{border:3px dashed #fff;padding:6% 25%;height:100%}@media (max-width:767px){.custom-file .custom-file-label[data-v-15ef0634]{padding:10px}}.custom-file .custom-file-label span[data-v-15ef0634]{transform:translateY(-50%);position:absolute;top:50%}.custom-file .custom-file-label[data-v-15ef0634]:after{position:absolute;border:none;width:85px;right:25%;top:42%}@media (max-width:767px){.custom-file .custom-file-label[data-v-15ef0634]:after{right:10px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-15ef0634","scoped":true,"hasInlineConfig":true}!./~/sass-loader/dist/cjs.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/elements/FileInput.vue
// module id = 8RVV
// module chunks = 0 1